import React from 'react';

import AuthLayout from '../../common/layout/auth/AuthLayout';
import RegisterForm from '../../auth/register/RegisterForm';
import registrationImg from '../../assets/images/tmf-portal-background-optimized.jpg';

const RegisterPage = () => (
  <AuthLayout path={registrationImg}>
    <RegisterForm />
  </AuthLayout>
);

export default RegisterPage;
